module.exports = __webpack_public_path__ + "img/square-caret-down.6d0c2553.svg";